export enum EContactType {
    Contact = 1,
    EmergencyContact = 2
}

